<template>
    <div>
        <h1>车e油测试页面</h1>
    </div>
</template>

<script>
export default {
    name: 'exit',
    data () {
        return {
            data:""
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
      


// WEBPACK FOOTER //
// src/components/car.vue